import { isEqual } from 'lodash'
import log from '@/logger'

const storage = storage => {
  const watchers = {}
  const watchersExpire = {}
  const prefixKey = name => `gr-${name}`

  const set = (key, value, ttlSeconds = null) => {
    const expiresAt = ttlSeconds ? new Date().getTime() + ttlSeconds * 1000 : null
    const data = {
      value,
      expiresAt
    }
    try {
      storage.setItem(prefixKey(key), JSON.stringify(data))
    } catch (e) {
      log.error(e)
    }
  }

  const _getData = key => {
    try {
      return JSON.parse(storage.getItem(prefixKey(key)))
    } catch (e) {
      del(key)
    }
  }

  const get = (key, defaultValue) => {
    const data = _getData(key)
    if (data !== null) {
      return data.value
    }
    return defaultValue
  }

  const cached = (key, defaultValue) => {
    const data = _getData(key)
    if (data !== null && data.expiresAt !== null && data.expiresAt > new Date().getTime()) {
      return data.value
    }
    return defaultValue
  }

  const watch = (key, callback) => {
    if (watchers[key]) {
      log.error('storage.watcher.already-exists', key)
      return
    }
    log.info('storage.watcher.set', key)
    let oldVal = get(key)
    const id = window.setInterval(() => {
      const newVal = get(key)
      if (!isEqual(oldVal, newVal)) {
        log.warn('storage.watcher.change-detected', { key, newVal })
        oldVal = newVal
        callback(newVal)
      }
    }, 250)
    watchers[key] = id
  }

  const watchExpire = key => {
    if (watchersExpire[key]) {
      log.error('storage.watcher-expire.already-exists', key)
      return
    }
    log.info('storage.watcher-expire.set', key)
    const id = window.setInterval(() => {
      const value = _getData(key)
      if (value && value.expiresAt < new Date().getTime()) {
        log.warn('storage.watcher-expire.delete', key)
        del(key)
      }
    }, 1000)
    watchersExpire[key] = id
  }

  const update = (key, value) => {
    const data = _getData(key)
    if (data !== null) {
      const payload = {
        value,
        expiresAt: data.expiresAt
      }
      try {
        storage.setItem(prefixKey(key), JSON.stringify(payload))
      } catch (e) {
        log.error(e)
      }
    }
  }

  const del = key => {
    try {
      storage.removeItem(prefixKey(key))
    } catch (e) {
      log.error(e)
    }
  }

  return {
    set,
    get,
    cached,
    watch,
    watchExpire,
    update,
    del
  }
}

const ls = storage(window.localStorage)
const ss = storage(window.sessionStorage)

export { ls, ss }
